import router from "@/plugins/router/document"

export default () => {
  return router
}
